import Card from "@pathwright/ui/src/components/card/Card"
import CoverPagePanelOfferCreateCohortGate from "@pathwright/features/src/modules/cover-pages/design/CoverPagePanelOfferCreateCohortGate"
import { ConnectStores } from "lib/core/store"
import ManageLicenseForm from "./ManageLicenseForm"

function ManageLicenseContainer(props) {
  const { onDirty, onPristine } = props

  return (
    <CoverPagePanelOfferCreateCohortGate>
      <ManageLicenseForm
        onDirty={() => onDirty?.()}
        onPristine={() => onPristine?.()}
      />
    </CoverPagePanelOfferCreateCohortGate>
  )
}

const ManageLicenseCard = ({ card }) => {
  return (
    <Card title="Member-created cohorts" card={card}>
      <ManageLicenseContainerConnected
        onDirty={() => card.setCardDirty(true)}
        onPristine={() => card.setCardDirty(false)}
      />
    </Card>
  )
}

ManageLicenseCard.displayName = "ManageLicenseCard"

const mapStateToProps = (state, ownProps) => {
  const { is_activated } = state.pathwrightAccountStore.state
  const { resource_licensing_enabled } = state.schoolStore.state.school

  return _.assign(
    {},
    {
      is_activated,
      resource_licensing_enabled
    },
    ownProps
  )
}

const stores = [
  { store: "school", watch: ["school"] },
  { store: "pathwrightAccount", watch: ["is_activated"] }
]

export const ManageLicenseContainerConnected = ConnectStores(
  ManageLicenseContainer,
  stores,
  {},
  mapStateToProps
)

export default ManageLicenseCard
